// eslint-disable-next-line no-restricted-imports
import $ from "jquery";

import "./jquery-migrate-1.1.1.js";
import "./jquery.mobile.vmouse.js";
import "./jquery.ui.position.js";

// @ts-expect-error -- We want to make jQuery global
window.jQuery = $;
// @ts-expect-error -- We want to make jQuery global
window.$ = $;

export {$ as default};
